import React from 'react';
import type { TransformedReport } from '../types';

interface BannerGridSlideProps {
  data: TransformedReport;
}

/**
 * BannerGridSlide - Slide 12: 4-column x 3-row grid (strategy label + 3 patterns).
 */
const BannerGridSlide: React.FC<BannerGridSlideProps> = ({ data }) => {
  const strategies = data.appeal_strategies ?? [];
  const banners = data.banners ?? [];

  // Group banners by strategy (3 per strategy)
  const strategyRows = strategies.slice(0, 3).map((strat, si) => {
    const stratBanners = banners.slice(si * 3, si * 3 + 3);
    return { strategy: strat, banners: stratBanners };
  });

  // Fallback if no strategies
  if (strategyRows.length === 0 && banners.length > 0) {
    // Show all banners in a single grid
    strategyRows.push({
      strategy: { name: 'Banner', direction: '' } as any,
      banners: banners.slice(0, 3),
    });
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="slide-hdr">
        <p className="sl">Step 03 — Banner</p>
        <h2>バナーデザイン一覧</h2>
        <p className="bt">
          {strategies.length >= 3
            ? `3つの訴求軸 x 3パターン、合計${Math.min(banners.length, 9)}枚のバナーを制作しました`
            : `バナーデザイン案をご提案します`}
        </p>
      </div>

      <div className="banner-grid" style={{ gridTemplateRows: `repeat(${strategyRows.length}, 1fr)` }}>
        {strategyRows.map((row, ri) => (
          <React.Fragment key={ri}>
            {/* Strategy label */}
            <div
              style={{
                background: '#1D1926',
                color: '#fff',
                borderRadius: 8,
                padding: 'clamp(8px, 1.2vmin, 16px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <p style={{ fontSize: 'clamp(11px, 1.6vmin, 14px)', fontWeight: 700, lineHeight: 1.4 }}>
                {row.strategy.name || ''}
              </p>
              {row.strategy.direction && (
                <p style={{ fontSize: 'clamp(9px, 1.2vmin, 11px)', color: 'rgba(255,255,255,0.5)', marginTop: 4 }}>
                  {row.strategy.direction}
                </p>
              )}
            </div>

            {/* 3 banner slots */}
            {[0, 1, 2].map((pi) => {
              const banner = row.banners[pi];
              return banner?.image_url ? (
                <div
                  key={pi}
                  style={{
                    borderRadius: 8,
                    overflow: 'hidden',
                    background: '#E4E0ED',
                  }}
                >
                  <img
                    src={banner.image_url}
                    alt={`Pattern ${String.fromCharCode(65 + pi)}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
              ) : (
                <div key={pi} className="ph" style={{ borderRadius: 8 }}>
                  Pattern {String.fromCharCode(65 + pi)}
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BannerGridSlide;
